import { h } from "vue";
import FontSpecimenVariableBlock from "../apps/FontSpecimenVariableBlock.vue";

export default () => {
    Array.prototype.unique = function () {
        return this.filter(function (value, index, self) {
            return self.indexOf(value) === index;
        })
    };


    if (!Array.prototype.last) {
        Array.prototype.last = function () {
            return this[this.length - 1];
        }
    };

	let newApp = document.querySelectorAll("#font-specimen-variable-block");

	for (let i = 0; i < newApp.length; i++) {
		new Vue ({
			el: newApp[i],
			render: (h) => h(FontSpecimenVariableBlock)
		});
	};
}
